import { useState } from "react";

import ContainerWithTabs from "Components/Admin/ContainerWithTabs";

import UpdateProjectDetails from "./Details";
import UpdateProjectsForm from "./Form";
import * as S from "./styles";

const UpdateProjects = () => {
  // Nome do projeto exibido acima das abas (pedido do cliente, 18/08/2026: o
  // admin não sabia qual projeto estava alterando).
  //
  // Quem informa é a aba "Detalhes", que JÁ busca o projeto — nenhuma requisição
  // nova. Ela é a aba padrão e monta primeiro; o nome fica neste estado e
  // sobrevive à troca de aba, mesmo com o ContainerWithTabs desmontando a aba
  // anterior.
  const [projectName, setProjectName] = useState(null);

  return (
    <ContainerWithTabs
      mt="0px"
      fitContent
      header={projectName ? <S.ProjectName>{projectName}</S.ProjectName> : null}
      tabs={[
        {
          title: "Detalhes",
          component: <UpdateProjectDetails onProjectLoaded={setProjectName} />,
        },
        {
          title: "Formulário",
          component: <UpdateProjectsForm />,
        },
      ]}
    />
  );
};

export default UpdateProjects;
